<template>
  <div class="home" v-if="assetsConfig">
    <div
      class="top-view"
      :class="showTopViewAni && 'top-view-fadeIn'"
      v-show="pageIndex === 1"
    >
      <NavigationBar
        :showBack="false"
        :title="assetsConfig.title"
      ></NavigationBar>
      <div
        class="fixed-navigation-bar flex"
        :style="{ top: $isHideNavbar ? 0 : $pxToVw(87) }"
      >
        <div
          class="nav-item"
          v-for="(item, index) in assetsConfig.last_screen"
          :key="index"
          :class="index === secondPageNavIndex && 'nav-item--active'"
          :style="{
            width: `${100 / assetsConfig.last_screen.length}%`,
            color:
              index === secondPageNavIndex
                ? item.title_color_active
                : item.title_color,
          }"
          @click="handleNavClick(item, index)"
        >
          {{ item.title }}
          <span
            v-show="index === secondPageNavIndex"
            class="nav-item--line"
            :style="{ backgroundColor: item.title_line_color_active }"
          ></span>
        </div>
      </div>
    </div>

    <swiper
      :options="swiperOptions"
      ref="pageSwiperRef"
      class="swiper-container"
    >
      <swiper-slide class="swiper-slide">
        <div
          class="first-page"
          :style="`background-image:url(${assetsConfig.first_screen.bg})`"
        ></div>
      </swiper-slide>

      <swiper-slide class="swiper-slide">
        <div class="second-page">
          <swiper
            ref="secondPageSwiperRef"
            class="second-page-swiper-container"
            :options="secPageOptions"
            @setTransition="handleSecondPageSetTransition"
            @touchMove="handleSecondPageSetTransition"
            @touchStart="handleSecondPageTouchesStart"
            :style="{
              paddingBottom: $isHideNavbar ? 0 : $pxToVw(100),
            }"
          >
            <swiper-slide
              class="swiper-slide"
              v-for="(moduleItem, index) in assetsConfig.last_screen || []"
              :key="index"
            >
              <div
                class="module-content"
                :id="moduleItem.id"
                :style="moduleItem.style"
                :ref="moduleItem.id"
              >
                <div
                  class="content-item"
                  v-for="(imgItem, iKey) in moduleItem.img_list"
                  :key="imgItem.src"
                  :ref="iKey === 0 ? 'firstEle' : ''"
                  :idx="index"
                  :style="{
                    paddingTop: $pxToVw(imgItem.pTop),
                    paddingLeft: $pxToVw(imgItem.pLeft),
                    paddingRight: $pxToVw(imgItem.pRight),
                    paddingBottom: $pxToVw(imgItem.pBottom),
                    ...imgItem.style,
                  }"
                >
                  <van-image
                    class="flex"
                    v-if="imgItem.src"
                    :src="imgItem.src"
                  />
                  <div
                    v-if="imgItem.type == contentType.video && imgItem.videoSrc"
                  >
                    <VideoPlayer
                      :poster="imgItem.poster"
                      :src="imgItem.videoSrc"
                      :videoName="imgItem.videoName"
                    ></VideoPlayer>
                  </div>
                  <div
                    v-if="
                      imgItem.type == contentType.zoomIn && imgItem.img_list
                    "
                  >
                    <AnimationGroup
                      :ref="imgItem.id"
                      :animationType="imgItem.animation_type"
                      :style="{
                        position: 'absolute',
                        zIndex: 9,
                        left: $pxToVw(imgItem.left) || 0,
                        top: $pxToVw(imgItem.top),
                        bottom: $pxToVw(imgItem.bottom),
                        width: imgItem.child_box_width || '100%',
                        height: imgItem.child_box_height || '100%',
                      }"
                      :imgList="imgItem.img_list"
                    ></AnimationGroup>
                  </div>
                  <div v-if="imgItem.type == contentType.tab">
                    <TabGroup
                      :title="imgItem.title"
                      :tabList="imgItem.tab_list"
                      :itemStyle="{
                        titleColor: imgItem.title_color,
                        itemTitleColor: imgItem.item_title_color,
                        itemTitleColorActive: imgItem.item_title_color_active,
                        itemTitleBorderRadius: imgItem.item_title_border_radius,
                        itemTitleBkColorActive:
                          imgItem.item_title_bk_color_active,
                        itemInfoBorderColor: imgItem.item_info_border_color,
                      }"
                    ></TabGroup>
                  </div>
                  <div v-if="imgItem.type == contentType.banners">
                    <BannerGroup
                      :bannerList="imgItem.banner_list"
                      :title="imgItem.title"
                      :itemStyle="{
                        titleColor: imgItem.title_color,
                        itemTitleColor: imgItem.item_title_color,
                        itemTitleColorActive: imgItem.item_title_color_active,
                        itemTitleBorderColorActive:
                          imgItem.item_title_border_color_active,
                        itemTitleBorderRadius: imgItem.item_title_border_radius,
                        itemBkColor: imgItem.item_bk_color,
                        itemDotColor: imgItem.item_dot_color,
                        itemDotColorActive: imgItem.item_dot_color_active,
                        itemDotBkColor: imgItem.item_dot_bk_color,
                        itemDotBkRadius: imgItem.item_dot_bk_radius,
                      }"
                    ></BannerGroup>
                  </div>
                  <div v-if="imgItem.type == contentType.brands">
                    <BrandGroup
                      :brandList="imgItem.brand_list"
                      :linkIcon="imgItem.item_link_icon"
                      @onclick="handleBrandClick"
                    ></BrandGroup>
                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </swiper-slide>
    </swiper>

    <div class="fixed-bottom-group">
      <img
        :src="
          assetsConfig.first_screen.icon_down ||
          require('../../assets/imgs/icon-down-arr.png')
        "
        class="icon-down"
        v-show="pageIndex === 0"
      />

      <!-- <div class="main-btn" @click="handleJoin">12312</div> -->
      <div
        class="main-btn"
        @click="handleJoin"
        :style="{
          color: assetsConfig.first_screen.join_btn_color,
          backgroundColor: assetsConfig.first_screen.join_btn_bk_color,
          borderRadius: assetsConfig.first_screen.join_btn_border_radius,
        }"
      >
        {{ assetsConfig.first_screen.join_btn_text || "一键加盟" }}
      </div>
    </div>

    <BrandPopupWindow
      v-if="popupInfo"
      @onclose="handlePopupClose"
      :popupInfo="popupInfo"
    ></BrandPopupWindow>
  </div>
</template>

<script>
import "swiper/css/swiper.css";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import NavigationBar from "../../components/navigationBar";
import AnimationGroup from "../../components/animationGroup";
import TabGroup from "../../components/tabGroup";
import BannerGroup from "../../components/bannerGroup";
import VideoPlayer from "../../components/videoPlayer";
import BrandGroup from "../../components/brandGroup";
import BrandPopupWindow from "../../components/brandPopupWindow";

import Util from "../../util";

import {
  TYPE_ZOOM_IN,
  TYPE_VIDEO,
  TYPE_TABDATA,
  TYPE_BANNERDATA,
  TYPE_BRANDS,
  TYPE_JUMP_POPUP,
  TYPE_JUMP_WEAPP,
} from "../../constant/types";

const baseSwiperOptions = {
  direction: "vertical",
  autoHeight: true, // 自适应高度
  // slidesPerView: "auto",
  resistanceRatio: 0,
};

export default {
  data() {
    return {
      showTopViewAni: false,
      // 内容类型
      contentType: {
        zoomIn: TYPE_ZOOM_IN,
        video: TYPE_VIDEO,
        tab: TYPE_TABDATA,
        banners: TYPE_BANNERDATA,
        brands: TYPE_BRANDS,
      },
      // 首页资源配置
      assetsConfig: "",
      // 页面索引
      pageIndex: 0,
      // 第二页顶部分类index
      secondPageNavIndex: 0,
      // 页面配置
      swiperOptions: {
        ...baseSwiperOptions,
        initialSlide: 0,
        on: {
          // 监听滑动切换事件，返回swiper对象
          slideChange: this.handlePageChange,
        },
      },
      // 第二页配置
      secPageOptions: {
        ...baseSwiperOptions,
        slidesPerView: "auto",
        nested: true,
        freeMode: true,
        on: {
          // 监听滑动切换事件，返回swiper对象
          slideChange: this.handleSecondPageSlideChange,
        },
      },
      // 弹窗信息
      popupInfo: "",
      // 所有需要播放动画的dom
      aniRefs: [],
      //   第二页每个模块的第一个元素
      secondPageFirstRefs: [],
      isClickChangeNav: false,
    };
  },
  created() {
    console.log('zame')
    window.OnConfigFnc((getConfig) => {
      const Config = getConfig(window.brand) || "";
      this.assetsConfig = Config;
      if (!Config || !Config.first_screen || !Config.first_screen.bg) {
        this.$router.replace({ path: "./empty", query: this.$route.query });
      }
      this.getAllAniRefs();
    });
  },
  methods: {
    // 从配置文件获取所有需要播放动画的类型
    getAllAniRefs() {
      this.$nextTick((e) => {
        const _aniRefs = [];
        if (!Array.isArray(this.assetsConfig.last_screen)) return;
        this.assetsConfig.last_screen.forEach((moduleItem) => {
          moduleItem.img_list.forEach((item) => {
            if (item && item.type === TYPE_ZOOM_IN) {
              if (this.$refs[item.id] && this.$refs[item.id].length > 0) {
                _aniRefs.push(this.$refs[item.id][0]);
              }
            }
          });
        });
        this.aniRefs = _aniRefs;
        this.secondPageFirstRefs = this.$refs.firstEle || [];
      });
      //   console.log("placeholder: ", this.aniRefs);
    },
    // 页面切换
    handlePageChange() {
      const _swiper = this.$refs.pageSwiperRef.$swiper;
      if (_swiper && _swiper.activeIndex >= 0) {
        this.pageIndex = _swiper.activeIndex;
        if (this.pageIndex === 1) {
          this.getAllAniRefs();
          setTimeout(() => {
            this.showTopViewAni = true;
          }, 10);
        } else {
          this.showTopViewAni = false;
        }
      }
    },
    // 第二页顶部分类切换
    handleNavClick(item, index) {
      this.isClickChangeNav = true;
      this.secondPageNavIndex = index;
      if (this.$refs[item.id] && this.$refs[item.id].length > 0) {
        this.$refs.secondPageSwiperRef.$swiper.slideTo(index, 300, false);
      }
    },
    // 第二页滑块切换
    handleSecondPageSlideChange() {
      const _swiper = this.$refs.secondPageSwiperRef.$swiper;
      if (_swiper && _swiper.activeIndex >= 0) {
        this.secondPageNavIndex = _swiper.activeIndex;
        this.updateIsPlayAnimation();
      }
    },
    // 第二页页面位置滚动事件
    handleSecondPageSetTransition() {
      this.updateIsPlayAnimation();
    },
    handleSecondPageTouchesStart() {
      this.isClickChangeNav = false;
    },
    // 更新是否需要播放入场动画
    updateIsPlayAnimation() {
      this.aniRefs.forEach((ref) => {
        if (ref.$el) {
          const rect = ref.$el.getBoundingClientRect();
          if (rect.top - document.documentElement.clientHeight < -200) {
            ref.playAnimation();
          }
        }
      });
      if (this.isClickChangeNav) return;
      this.secondPageFirstRefs.forEach((ref) => {
        const rect = ref.getBoundingClientRect();
        if (rect && rect.top - document.documentElement.clientHeight < 0) {
          this.secondPageNavIndex = Number(ref.getAttribute("idx"));
        }
      });
    },
    // 底部品牌点击
    handleBrandClick(item) {
      if (!item) return;
      //   品牌类型是弹窗 或者 需要跳转的link为空 则显示弹窗
      if (
        item.open_type === TYPE_JUMP_POPUP ||
        (Util.isEmptyString(item.link) && !Util.isEmptyString(item.popSrc))
      ) {
        this.popupInfo = item;
      } else if (!Util.isEmptyString(item.link)) {
        if (item.open_type === TYPE_JUMP_WEAPP) {
          window.location.href = item.link;
        } else {
          this.$router.push({ path: "./webview", query: { href: item.link } });
        }
      }
    },
    // 关闭 弹窗
    handlePopupClose() {
      this.popupInfo = "";
    },
    handleJoin() {
      window.sensors.track("JoinPageClick", {
        join_module_name: "一键加盟",
        join_name: this.assetsConfig.first_screen.join_btn_text || "一键加盟",
        join_destination_url: "",
      });
      this.$router.push({ path: "./submit", query: this.$route.query });
    },
  },
  components: {
    Swiper,
    SwiperSlide,
    NavigationBar,
    AnimationGroup,
    VideoPlayer,
    TabGroup,
    BannerGroup,
    BrandGroup,
    BrandPopupWindow,
  },
};
</script>

<style lang="scss" scoped>
  .navigation-bar {
    position: relative;
  }
  .home {
    .swiper-container {
      width: 100%;
      height: 100vh;
    }

    .second-page-swiper-container {
      padding-bottom: 100px;
    }

    .fixed-navigation-bar {
      position: fixed;
      //   position: sticky;
      left: 0;
      top: 87px;
      z-index: 9;
      width: 100%;
      height: 96px;
      line-height: 96px;
      background-color: white;
      z-index: 99;
      .nav-item--line {
        position: absolute;
        width: 112px;
        height: 5px;
        background-color: #009602;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
      }
      .nav-item {
        width: 33%;
        height: 100%;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        position: relative;

        &--active {
          font-size: 28px;
          font-weight: 600;
          color: #009602;
        }
      }
    }

    .first-page {
      width: 100%;
      height: 100vh;
      background-size: 100% auto;
      background-position: center;
      background-repeat: no-repeat;
    }

    .second-page {
      position: relative;
      width: 100%;
      min-height: 100%;
      height: 100vh;
      overflow: auto;
      .module-content {
        .content-item {
          position: relative;
          margin: auto;
        }
      }

      //   .swiper-slide:first-of-type {
      //     padding-top: 96px;
      //   }
    }

    .swiper-slide {
      -webkit-overflow-scrolling: touch;
      background-color: white;
    }

    .fixed-bottom-group {
      position: fixed;
      width: 100%;
      z-index: 9;
      left: 0;
      bottom: 46px;
      //   bottom: 40px;
      //   bottom: calc(40px + constant(safe-area-inset-bottom));
      //   bottom: calc(40px + env(safe-area-inset-bottom));
      .icon-down {
        width: 60px;
        height: 60px;
        margin: 0 auto 44px;
        position: relative;
        animation: dropAndBounce 1.6s infinite;
        animation-timing-function: ease-in-out;
      }
    }
  }

  .top-view {
    position: relative;
    z-index: 99;
    transform: translateY(-100px);
    opacity: 0.5;
    transition: all 0.5s ease;
  }

  .top-view-fadeIn {
    opacity: 1;
    transform: translateY(0);
  }

  @keyframes dropAndBounce {
    0%,
    100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(40px);
    }
  }
</style>